import { render } from "./AccountPartnerForm.vue?vue&type=template&id=161798ec"
import script from "./AccountPartnerForm.vue?vue&type=script&lang=js"
export * from "./AccountPartnerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__